// extracted by mini-css-extract-plugin
export var center = "_1s-2";
export var clickableRow = "_1s-5";
export var expandedRow = "_1s-7";
export var hoverable = "_1s-4";
export var left = "_1s-1";
export var right = "_1s-3";
export var row = "_1s-0";
export var selectedRow = "_1s-6";
export var summaryRow = "_1s-8";